// Main script for WF1999 Classified Archive
import Screensavers from './includes/1999-screensavers';
import {playSound, stopSound, MEDIA_DIR, DecryptSuccessAudio} from './includes/1999-audio';
import {getAppState, loadAppState, restoreAppState, saveAppState, addSyncHandler, syncAppState} from './includes/1999-state';

const CLASS_ACTIVE = "is-active";
const CLASS_HIDDEN = "is-hidden";
const CLASS_LOCKED = "is-locked";
const CLASS_UNLOCKED = "is-unlocked";
const CLASS_LOADED = "is-loaded";
const CLASS_LOADING = "is-loading";
const CLASS_FOCUSED = "is-focused";
const CLASS_DOWNLOADED = "is-downloaded";
const CLASS_OPEN = "is-open";
const CLASS_ERROR = "is-error";

const FileIconTemplate = document.getElementById("file-icon");
const MessageBoardElement = document.querySelector(".MessageBoard");
const MessageBoardBackground = document.querySelector(".MessageBoard-background");
const MessageBoardDesktop = document.querySelector(".MessageBoard-desktop");

const MouseClickAudio = new Audio(MEDIA_DIR+'mouse-click.mp3');
const FileCloseAudio = new Audio(MEDIA_DIR+'file-close.mp3');
const WindowOpenAudio = new Audio(MEDIA_DIR+'window-open.mp3');
const WindowCloseAudio = new Audio(MEDIA_DIR+'window-close.mp3');
const MessageSentAudio = new Audio(MEDIA_DIR+'message-sent.mp3');
const MessageReceivedAudio = new Audio(MEDIA_DIR+'message-received.mp3');
const ErrorAudio = new Audio(MEDIA_DIR+'error.mp3');
const DecryptLoopAudio = new Audio(MEDIA_DIR+'decrypt-loop.mp3');
const DecryptStepAudio = new Audio(MEDIA_DIR+'decrypt-step.mp3');
const DecryptErrorAudio = new Audio(MEDIA_DIR+'decrypt-error.mp3');
const UnzipAudio = new Audio(MEDIA_DIR+'unzip.mp3');
const HardDriveAudio5s = new Audio(MEDIA_DIR+'hard-drive-working-5s.mp3');
const OllieMovesAudio = new Audio(MEDIA_DIR+'ollie-moves.mp3');
const ConnectAudio = new Audio(MEDIA_DIR+'connect.mp3');
const ConnectedAudio = new Audio(MEDIA_DIR+'connected.mp3');
const PowerOnAudio = new Audio(MEDIA_DIR+'power-on.mp3');
const PowerOffAudio = new Audio(MEDIA_DIR+'power-off.mp3');
const DriveCorruptedAudio = new Audio(MEDIA_DIR+'drive-corrupted.mp3');
const DriveRepairedAudio = new Audio(MEDIA_DIR+'drive-repaired.mp3');
const DriveOpenAudio = new Audio(MEDIA_DIR+'drive-open.mp3');
const DriveRecoverAudio = new Audio(MEDIA_DIR+'drive-recover.mp3');
const AccessLoopAudio = new Audio(MEDIA_DIR+'decrypt-loop.mp3');
AccessLoopAudio.loop = true;

const HotBarSettings = document.querySelector('.HotBarIcon[data-name="settings"]');
const HotBarEmail = document.querySelector('.HotBarIcon[data-name="email"]');
const HotBarSearch = document.querySelector('.HotBarIcon[data-name="search"]');
const HotBarDocuments = document.querySelector('.HotBarIcon[data-name="documents"]');
const HotBarDatabase = document.querySelector('.HotBarIcon[data-name="database"]');
const HotBarHardware = document.querySelector('.HotBarIcon[data-name="hardware"]');
const HotBarNetworking = document.querySelector('.HotBarIcon[data-name="networking"]');
const HotBarRecycle = document.querySelector('.HotBarIcon[data-name="recycle"]');
const HotBarPower = document.querySelector('.HotBarIcon[data-name="power"]');

const files = [];
const WindowElements = document.querySelectorAll(".DesktopWindow");
const windows = [];
const activeWindows = [];

// Copied from warframe.js
const DocumentBody = document.querySelector('body');
function tryPushDataLayer(payload) {
    try {
        const p = {
            ...payload,
            authentication_status: DocumentBody.classList.contains('logged-in') ? 1 : 0,
        };
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(p);
    } catch (e) {
        console.error('Error trying to push to datalayer: ' + e);
    }
}
function addDataLayerListener({element, event, payload, transform}) {
    element.addEventListener(event, (e) => {
        transform && transform(element, payload);
        tryPushDataLayer(payload);
    });
}
function addDataLayerTrigger({selector, event, payload, transform}) {
    const elements = document.querySelectorAll(selector);
    if (elements && elements.length > 0) {
        for (let i = 0; i < elements.length; i ++) {
            addDataLayerListener({
                element: elements[i],
                event,
                payload,
                transform
            });
        }
    }
}

let lastUserActivity = Date.now();
window.PageData = window.PageData || {}; // Pulled in from page

function appSyncHandler(state) {
    const isEmailNotificationActive = !state.email1Read
        || (state.emailReplyReceived && !state.emailReplyRead);
    HotBarEmail.classList.toggle('has-reply', isEmailNotificationActive);

    const WelcomeFileIcon = document.querySelector('.FileIcon[data-file="welcome"]');
    WelcomeFileIcon.classList.toggle(CLASS_HIDDEN, !state.recycleRestored);
    const LureFileIcon = document.querySelector('.FileIcon[data-file="lure"]');
    LureFileIcon.classList.toggle(CLASS_HIDDEN, !state.recycleRestored);
    LureFileIcon.classList.toggle(CLASS_LOCKED, !state.lureUnlocked);
    const CheatFileIcon = document.querySelector('.FileIcon[data-file="cheat"]');
    CheatFileIcon.classList.toggle(CLASS_HIDDEN, !state.oublietteUnpacked);
    CheatFileIcon.classList.toggle(CLASS_LOCKED, !state.cheatUnlocked);
    const SpeakFileIcon = document.querySelector('.FileIcon[data-file="speak"]');
    SpeakFileIcon.classList.toggle(CLASS_HIDDEN, !state.speakRevealed);
    SpeakFileIcon.classList.toggle(CLASS_LOCKED, !state.speakUnlocked);
    const PaperFileIcon = document.querySelector('.FileIcon[data-file="paper"]');
    PaperFileIcon.classList.toggle(CLASS_HIDDEN, !state.emailAttachmentDownloaded);
    PaperFileIcon.classList.toggle(CLASS_LOCKED, !state.paperUnlocked);
    const BiteFileIcon = document.querySelector('.FileIcon[data-file="bite"]');
    BiteFileIcon.classList.toggle(CLASS_HIDDEN, !state.biteRevealed);
    BiteFileIcon.classList.toggle(CLASS_LOCKED, !state.biteUnlocked);
    const ContactFileIcon = document.querySelector('.FileIcon[data-file="contact"]');
    ContactFileIcon.classList.toggle(CLASS_HIDDEN, !state.contactRevealed);
    ContactFileIcon.classList.toggle(CLASS_LOCKED, !state.contactUnlocked);

    const RecycleFile1 = document.getElementById('hidden-file-1');
    const RecycleFile2 = document.getElementById('hidden-file-2');
    RecycleFile1.classList.toggle(CLASS_HIDDEN, state.recycleRestored);
    RecycleFile2.classList.toggle(CLASS_HIDDEN, state.recycleRestored);

    const DecryptApp = document.querySelector('.FileIcon[data-file="decrypt"]');
    DecryptApp.classList.toggle(CLASS_HIDDEN, !state.decryptDownloaded);
    const DecryptDownload = document.querySelector('.BrowserDecryptDownload');
    DecryptDownload.classList.toggle(CLASS_DOWNLOADED, state.decryptDownloaded);
    syncDecryptApp();
    const OublietteFileIcon = document.querySelector('.FileIcon[data-file="oubliette"]');
    OublietteFileIcon.classList.toggle(CLASS_HIDDEN, state.oublietteUnpacked);
    OublietteFileIcon.classList.toggle(CLASS_LOCKED, !state.oublietteDecrypted);
    const OublietteWindow = document.querySelector('.DesktopWindow[data-id="oubliette"]');
    const OublietteEncryption = OublietteWindow.querySelector('.EncryptedContents');
    const OublietteCloser = OublietteWindow.querySelector('.EncryptedContents-button');
    OublietteEncryption.classList.toggle(CLASS_UNLOCKED, state.oublietteDecrypted);
    OublietteCloser.addEventListener('click', (e) => {
        e.stopPropagation();
        interfaceClick(false);
        playSound(FileCloseAudio);
        closeWindow('oubliette');
    });

    syncSettings();
    syncPasswordProtection();

    const LlamaPage = document.querySelector('.BrowserLlama');
    LlamaPage.classList.toggle(CLASS_DOWNLOADED, state.llamaUnlocked);
    syncMusicPlayerUI();
}

function updateUserActivity() {
    lastUserActivity = Date.now();
}
function interfaceClick(sound = true) {
    updateUserActivity();
    if (sound) {
        playSound(MouseClickAudio);
    }
}

function addFileIcon(file) {
    const {
        id, target, type, label,
        hidden=false, locked='false', app='false'
    } = file;
    const icon = FileIconTemplate.content.cloneNode(true);
    const iconElement = icon.querySelector('.FileIcon');
    const iconLabel = iconElement.querySelector('.FileIcon-label');
    iconElement.setAttribute('data-file', id);
    iconElement.classList.toggle(CLASS_HIDDEN, hidden);
    iconElement.classList.toggle(CLASS_LOCKED, locked);
    iconElement.classList.add('FileIcon--' + (type || 'text'));
    iconLabel.innerText = label;
    MessageBoardDesktop.appendChild(icon);

    const f = {
        id,
        icon: iconElement,
    }
    if (target) {
        const docElement = document.querySelector(`.DesktopWindow[data-id="${target}"]`);
        if (docElement) {
            const docTitle = docElement.querySelector('.DesktopWindow-title');
            docTitle.innerText = label;
            f.docElement = docElement;
        }
        iconElement.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            openWindow(target);
            interfaceClick(!app);
            if (app) playSound(WindowOpenAudio);
        });
    }

    files.push(f);
}

function isWindowOpen(id) {
    for (const win of windows) {
        if (win.id === id) {
            return win.element.classList.contains(CLASS_ACTIVE);
        }
    }
    return false;
}
function getWindow(id) {
    for (const win of windows) {
        if (win.id === id) {
            return win;
        }
    }
    return null;
}
function openWindow(id, reset=false, sound=false) {
    for (const win of windows) {
        if (win.id === id) {
            if (sound && !win.element.classList.contains(CLASS_ACTIVE)) {
                playSound(WindowOpenAudio);
            }
            if (win.element.hasAttribute('data-async') && win.open) {
                win.open();
            }
            win.element.classList.toggle(CLASS_ACTIVE, true);
            if (reset && win.reset) win.reset();
            syncWindowStack(win);
            break;
        }
    }
}
function closeWindow(id=null, sound=false) {
    if (id === null) {
        if (activeWindows.length > 0) {
            closeWindow(activeWindows[activeWindows.length-1].id, sound);
        }
    } else {
        for (const win of windows) {
            if (win.id === id) {
                if (sound && win.element.classList.contains(CLASS_ACTIVE)) {
                    playSound(WindowCloseAudio);
                }
                win.element.classList.toggle(CLASS_ACTIVE, false);
                removeActiveWindow(id);
                break;
            }
        }
    }
    syncWindowStack();
}
function closeAllWindows() {
    while(activeWindows.length > 0) {
        closeWindow(activeWindows[0].id);
    }
}

function removeActiveWindow(id) {
    for (let i = 0; i < activeWindows.length; i ++) {
        if (activeWindows[i].id === id) {
            activeWindows.splice(i, 1);
            return;
        }
    }
    syncWindowStack();
}

function centerWindow(element, x=0.5, y=0.5) {
    const rect = element.getBoundingClientRect();
    const top = (window.innerHeight - rect.height) * y;
    const left = (window.innerWidth - rect.width) * x;
    element.style.top = top + 'px';
    element.style.left = left + 'px';
}

function syncWindowStack(focusWindow=null) {
    if (activeWindows.length < 1 && focusWindow == null) return;

    if (focusWindow) {
        const index = activeWindows.findIndex((e) => e === focusWindow);
        if (index > -1) {
            activeWindows.splice(index, 1);
        }
        activeWindows.push(focusWindow);
    }
    for (let i = 0; i < activeWindows.length; i ++) {
        const win = activeWindows[i];
        win.element.style.zIndex = i + 1;
        win.element.classList.toggle(CLASS_FOCUSED, i === (activeWindows.length - 1));
    }
}

// Email app
function openEmailWindow() {
    interfaceClick(false);
    const appState = getAppState();
    if (appState.emailReplyReceived) {
        openWindow('email-2', true, true);
        appState.emailReplyRead = true;
        saveAppState();
        syncAppState();
    } else {
        openWindow('email-1', true, true);
        appState.email1Read = true;
        saveAppState();
        syncAppState();
    }
}

function email1ReplyHandler(e) {
    e.stopPropagation();
    interfaceClick();
    openWindow('email-reply', true);
}

function emailReplySendHandler(e) {
    e.preventDefault();
    e.stopPropagation();

    const value = EmailReplyField.value.trim().toLowerCase();
    if (value !== "") {
        interfaceClick(false);
        closeWindow('email-reply');
        closeWindow('email-1');
        playSound(MessageSentAudio);

        let title = 'locked';
        if (value.indexOf("pineapple") > -1 && value.indexOf("duh") > -1) {
            title = 'unlocked';
            setTimeout(() => {
                getAppState().emailReplyReceived = true;
                saveAppState();
                syncAppState();
                playSound(MessageReceivedAudio);
            }, 3000);
        }

        tryPushDataLayer({
            event: 'button_click',
            creative_title: title,
            creative_type: 'button',
            creative_placement: 'email_send',
        });
    }
}

function emailAttachmentHandler() {
    interfaceClick();
    getAppState().emailAttachmentDownloaded = true;
    saveAppState();
    syncAppState();
}

const Email1ReplyButton = document.querySelector('.DesktopWindow[data-id="email-1"] .EmailApp-button');
const EmailReplyWindow = document.querySelector('.DesktopWindow[data-id="email-reply"]');
const EmailReplyForm = EmailReplyWindow.querySelector('form.EmailApp');
const EmailReplyField = EmailReplyWindow.querySelector('.EmailApp-body');
const EmailReplySendButton = EmailReplyWindow.querySelector('.EmailApp-button');
const Email2Window = document.querySelector('.DesktopWindow[data-id="email-2"]');
const Email2ReplyButton = Email2Window.querySelector('.EmailApp-button');
const Email2Footer = Email2Window.querySelector('.EmailApp-footer');
function setupEmailApp() {
    Email1ReplyButton.addEventListener('click', email1ReplyHandler);
    EmailReplyForm.addEventListener('submit', emailReplySendHandler);
    EmailReplyField.addEventListener('keydown', () => {
       updateUserActivity();
    });
    EmailReplySendButton.addEventListener('click', emailReplySendHandler);
    Email2Footer.addEventListener('click', emailAttachmentHandler);
    Email2ReplyButton.addEventListener('click', () => {
        playSound(DecryptErrorAudio);
    });
}

// Search app
const SearchWindow = document.querySelector('.DesktopWindow[data-id="search"]');
const SearchCloser = SearchWindow.querySelector('.DesktopWindow-close');
const SearchPages = SearchWindow.querySelectorAll('.BrowserApp-page');
const SearchLoaderLines = SearchWindow.querySelectorAll('.BrowserSearchLoader-textLine');
const SearchForm = SearchWindow.querySelector('.BrowserSearchApp');
const SearchField = SearchWindow.querySelector('.BrowserSearchApp-inputField');
const SearchRecents = SearchWindow.querySelector('.BrowserSearchApp-recents');
const SearchBackLinks = SearchWindow.querySelectorAll('.BrowserBreadcrumbs-back');
const SearchDecryptDownload = SearchWindow.querySelector('.BrowserDecryptDownload-download .BrowserDecryptDownload-button');
const SearchDecryptDownloaded = SearchWindow.querySelector('.BrowserDecryptDownload-downloaded .BrowserDecryptDownload-button');
//const SearchOnLyneLink = SearchRecents.querySelector('#search-recent-onlyne');
//const SearchAtomicycleLink = SearchRecents.querySelector('#search-recent-atomicycle');
//const SearchProtoframesLink = SearchRecents.querySelector('#search-recent-protoframes');
const SearchDecryptAboutLink = SearchWindow.querySelector('.BrowserDecryptDownload-link[data-id="about"]');
const SearchDecryptReturnLink = SearchWindow.querySelector('.BrowserBreadcrumbs-return');
const SearchDecryptLink = SearchRecents.querySelector('#search-recent-decrypt');
const SearchLlamaPage = SearchWindow.querySelector('.BrowserLlama');
const SearchLlamaDownload = SearchLlamaPage.querySelector('.BrowserLlama-download .BrowserLlama-button');
const SearchLlamaCompleted = SearchLlamaPage.querySelector('.BrowserLlama-downloaded .BrowserLlama-button');
const SearchLoadingOverlay = SearchWindow.querySelector('.BrowserApp-loading');
const SearchLoadingInner = SearchLoadingOverlay.querySelector('.BrowserBreadcrumbs');
let searchInteractionLockout = Date.now();
function trySearchInteraction(lockoutDuration=0) {
    const timestamp = Date.now();
    if (timestamp > searchInteractionLockout) {
        searchInteractionLockout = timestamp + lockoutDuration;
        return true;
    }
    return false;
}
function openSearchView(id) {
    SearchPages.forEach((page, index) => {
        page.classList.toggle(CLASS_ACTIVE, index === id);
    });
}
function doSearchLoad() {
    if (trySearchInteraction(5000)) {
        const LoaderChars = SearchWindow.querySelectorAll('.BrowserSearchLoader-loaderCharacter');
        let charIndex = -1;
        function cycleChar() {
            charIndex ++;
            if (charIndex > 3) charIndex = 0;
            LoaderChars.forEach((c, i) => {
                c.classList.toggle(CLASS_ACTIVE, i === charIndex);
            });
        }
        let interval = setInterval(cycleChar, 125);
        playSound(HardDriveAudio5s, 0.4);

        SearchRecents.classList.toggle(CLASS_ACTIVE, false);
        SearchField.value = "";

        SearchLoaderLines.forEach((line) => line.classList.toggle(CLASS_ACTIVE, false));
        openSearchView(0);
        SearchLoaderLines[4].classList.toggle(CLASS_ACTIVE, true);
        setTimeout(() => {
            SearchLoaderLines[0].classList.toggle(CLASS_ACTIVE, true);
        }, 1000);
        setTimeout(() => {
            SearchLoaderLines[1].classList.toggle(CLASS_ACTIVE, true);
        }, 3000);
        setTimeout(() => {
            SearchLoaderLines[2].classList.toggle(CLASS_ACTIVE, true);
        }, 3500);
        setTimeout(() => {
            SearchLoaderLines[3].classList.toggle(CLASS_ACTIVE, true);
        }, 4000);
        setTimeout(() => {
            HardDriveAudio5s.pause();
            openSearchView(1);
            clearInterval(interval);
        }, 5000);
    }
}
function openSearchWindow() {
    if (!SearchWindow.classList.contains(CLASS_ACTIVE)) {
        openWindow('search', true);
        doSearchLoad();
        interfaceClick(false);
        playSound(WindowOpenAudio);
    }
}
const MAX_LOAD_CHARS = 80;
const LOAD_CHARS_TICK = 50;
const LoadChars = Array(MAX_LOAD_CHARS);
function shuffleLoadChars() {
    LoadChars.fill(30, 0);
    LoadChars.fill(20, 10);
    LoadChars.fill(10, 40);
    LoadChars.fill(0, 50);

    let currentIndex = LoadChars.length;
    while (currentIndex > 0) {
        let randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;
        [LoadChars[currentIndex], LoadChars[randomIndex]] = [LoadChars[randomIndex], LoadChars[currentIndex]];
    }
}
function doSearchLoadingAction(callback, duration=1000, feedback) {
    if (trySearchInteraction(duration)) {
        if (feedback) {
            feedback();
        } else {
            interfaceClick();
        }

        if (duration < 1) {
            callback();
            return;
        }
        shuffleLoadChars();
        const IncrementValue = (1000 / duration) * LOAD_CHARS_TICK;
        let elapsed = 0;
        let loadIndex = 0;
        let amount;
        let interval;

        function loadTick() {
            if (elapsed < duration) {
                amount = IncrementValue;
                while (loadIndex < MAX_LOAD_CHARS && amount >= LoadChars[loadIndex]) {
                    amount -= LoadChars[loadIndex];
                    loadIndex ++;
                }
                if (loadIndex < MAX_LOAD_CHARS && amount > 0) {
                    LoadChars[loadIndex] -= amount;
                }
                SearchLoadingInner.innerText = "".padStart(loadIndex + 1, ">");
                elapsed += LOAD_CHARS_TICK;
            }
            else
            {
                HardDriveAudio5s.pause();
                clearTimeout(interval);
                SearchLoadingOverlay.classList.toggle(CLASS_ACTIVE, false);
                callback();
            }
        }

        playSound(HardDriveAudio5s, 0.4);

        SearchLoadingInner.innerText = "";
        SearchLoadingOverlay.classList.toggle(CLASS_ACTIVE, true);
        interval = setInterval(loadTick, LOAD_CHARS_TICK);
    }
}
function check2(str) {
    if (str === null || str === "") return false;
    let u = false;
    let v = false;
    let w = false;
    let x = false;
    let y = false;
    let z = false;
    const tokens = str.split(/\s+/g);
    for (const token of tokens) {
        switch (simpleHash(token)) {
            case -2268520427:
                u = true;
                break;
            case 2915921897:
                v = true;
                break;
            case 907851184:
                w = true;
                break;
            case 836013910:
                x = true;
                break;
            case -3352156767:
                y = true;
                break;
            case 6044773349:
                z = true;
                break;
        }
    }
    return u || w || (x && y) || (z && y);
}
function searchSubmitHandler(e) {
    e.preventDefault();
    e.stopPropagation();
    doSearchLoadingAction(() => {
        const search = SearchField.value.trim().toLowerCase();

        if (search.indexOf("crypt") > -1 || search.indexOf("crack") > -1) {
            openSearchView(2);
        } else if (check2(search)) {
            openSearchView(5);
        } else {
            openSearchView(3);
        }

    }, 2000 + (Math.random() * 1000));
    SearchRecents.classList.toggle(CLASS_ACTIVE, false);
}
function searchBackHandler(e) {
    e.preventDefault();
    e.stopPropagation();
    doSearchLoadingAction(() => {
        SearchField.value = "";
        SearchRecents.classList.toggle(CLASS_ACTIVE, false);
        openSearchView(1);
    });
}
function searchFieldEventHandler(e) {
    SearchRecents.classList.toggle(CLASS_ACTIVE, true);
}
function searchDecryptLinkHandler(e) {
    e.preventDefault();
    e.stopPropagation();
    SearchRecents.classList.toggle(CLASS_ACTIVE, false);
    SearchField.value = SearchDecryptLink.innerText;
    doSearchLoadingAction(() => {
        openSearchView(2);
    }, 3000);
}
function searchDecryptDownloadHandler(e) {
    e.stopPropagation();

    doSearchLoadingAction(() => {
        getAppState().decryptDownloaded = true;
        saveAppState();
        syncAppState();
    }, 5000);
}
function searchCloseHandler(e) {
    e.stopPropagation();
    closeWindow('search', true);
}
function searchDecryptAboutHandler(e) {
    e.preventDefault();
    e.stopPropagation();
    doSearchLoadingAction(() => {
        openSearchView(4);
    }, 1000);
}
function searchDecryptBackHandler(e) {
    e.preventDefault();
    e.stopPropagation();
    doSearchLoadingAction(() => {
        openSearchView(2);
    }, 1000);
}
function searchLlamaDownloadHandler(e) {
    e.preventDefault();
    e.stopPropagation();
    doSearchLoadingAction(() => {
        getAppState().llamaUnlocked = true;
        saveAppState();
        syncAppState();
    }, 3000 + Math.random() * 2000);
}
function setupSearchApp() {
    SearchCloser.addEventListener('click', () => {
        stopSound(HardDriveAudio5s);
    });
    SearchForm.addEventListener('submit', searchSubmitHandler);
    SearchField.addEventListener('click', searchFieldEventHandler);
    SearchField.addEventListener('focus', searchFieldEventHandler);
    SearchBackLinks.forEach((link) => link.addEventListener('click', searchBackHandler));
    SearchDecryptLink.addEventListener('click', searchDecryptLinkHandler);
    SearchDecryptDownload.addEventListener('click', searchDecryptDownloadHandler);
    SearchDecryptDownloaded.addEventListener('click', searchCloseHandler);
    SearchDecryptAboutLink.addEventListener('click', searchDecryptAboutHandler);
    SearchDecryptReturnLink.addEventListener('click', searchDecryptBackHandler);
    SearchLlamaDownload.addEventListener('click', searchLlamaDownloadHandler);
    SearchLlamaCompleted.addEventListener('click', searchCloseHandler);
}

// Decrypt app
const DecryptWindow = document.querySelector('.DesktopWindow[data-id="decrypt"]');
const DecryptLockA = DecryptWindow.querySelector('.DecryptApp-lock[data-id="0"]');
const DecryptLockB = DecryptWindow.querySelector('.DecryptApp-lock[data-id="1"]');
const DecryptLockC = DecryptWindow.querySelector('.DecryptApp-lock[data-id="2"]');
const DecryptLockD = DecryptWindow.querySelector('.DecryptApp-lock[data-id="3"]');
const DecryptFolder = DecryptWindow.querySelector('.DecryptApp-folder');
const DecryptProgressBar = DecryptWindow.querySelector('.DecryptApp-progressBar');
const DecryptProgress = DecryptWindow.querySelector('.DecryptApp-progressValue');

function syncDecryptApp() {
    const appState = getAppState();
    DecryptLockA.classList.toggle(CLASS_UNLOCKED, appState.decryptStep > 1);
    DecryptLockB.classList.toggle(CLASS_UNLOCKED, appState.decryptStep > 0);
    DecryptLockC.classList.toggle(CLASS_UNLOCKED, appState.decryptStep > 3);
    DecryptLockD.classList.toggle(CLASS_UNLOCKED, appState.decryptStep > 2);
    DecryptFolder.classList.toggle(CLASS_UNLOCKED, appState.decryptStep > 3);
    DecryptProgressBar.style.width = (25 * appState.decryptStep) + '%';
    DecryptProgress.innerText = 25 * appState.decryptStep;
}
function decryptSave(step, error=false) {
    const appState = getAppState();
    appState.decryptStep = step;
    appState.oublietteDecrypted = appState.decryptStep > 3;
    if (error) {
        saveAppState();
        syncAppState();
        interfaceClick(false);
        playSound(DecryptErrorAudio, 0.5);

        tryPushDataLayer({
            event: 'button_click',
            creative_title: 'locked',
            creative_type: 'button',
            creative_placement: 'decrypter',
        });
    } else {
        saveAppState();
        syncAppState();
        interfaceClick(false);
        if (appState.decryptStep === 4) {
            playSound(DecryptSuccessAudio, 0.5);

            tryPushDataLayer({
                event: 'button_click',
                creative_title: 'unlocked',
                creative_type: 'button',
                creative_placement: 'decrypter',
            });
        } else {
            playSound(DecryptStepAudio, 0.5);
        }
    }
}
function decryptAClickHandler() {
    const appState = getAppState();
    if (appState.decryptStep === 1) {
        decryptSave(2, false);
    } else if (appState.decryptStep < 4) {
        decryptSave(0, true);
    }
}
function decryptBClickHandler() {
    const appState = getAppState();
    if (appState.decryptStep === 0) {
        decryptSave(1, false);
    } else if (appState.decryptStep < 4) {
        decryptSave(0, true);
    }
}
function decryptCClickHandler() {
    const appState = getAppState();
    if (appState.decryptStep === 3) {
        decryptSave(4, false);
    } else if (appState.decryptStep < 4) {
        decryptSave(0, true);
    }
}
function decryptDClickHandler() {
    const appState = getAppState();
    if (appState.decryptStep === 2) {
        decryptSave(3, false);
    } else if (appState.decryptStep < 4) {
        decryptSave(0, true);
    }
}

function setupDecryptApp() {
    const OublietteIcon = document.querySelector('.FileIcon[data-file="oubliette"]');
    OublietteIcon.addEventListener('click', () => {
       tryPushDataLayer({
           event: 'button_click',
           creative_title: getAppState().oublietteDecrypted ? 'unlocked' : 'locked',
           creative_type: 'button',
           creative_placement: 'oubliette',
       });
    });
    const DecryptIcon = document.querySelector('.FileIcon[data-file="decrypt"]');
    DecryptIcon.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        openWindow('decrypt');
        interfaceClick(false);
        playSound(WindowOpenAudio);
        DecryptLoopAudio.loop = true;
        setTimeout(() => playSound(DecryptLoopAudio, 0.5), 500);

        tryPushDataLayer({
            event: 'button_click',
            creative_title: getAppState().oublietteDecrypted ? 'unlocked' : 'locked',
            creative_type: 'button',
            creative_placement: 'decrypter',
        });
    });
    const DecryptCloser = DecryptWindow.querySelector('.DesktopWindow-close');
    DecryptCloser.addEventListener('click', () => {
        stopSound(DecryptLoopAudio);
    });
    DecryptLockA.addEventListener('click', decryptAClickHandler);
    DecryptLockB.addEventListener('click', decryptBClickHandler);
    DecryptLockC.addEventListener('click', decryptCClickHandler);
    DecryptLockD.addEventListener('click', decryptDClickHandler);
}

// Unzip
function unzipOubliette() {
    getAppState().oublietteUnpacked = true;
    saveAppState();
    syncAppState();
    playSound(UnzipAudio);
    closeWindow('oubliette');
}

// Documents
function setupTextEditor(parent) {
    const BaseElement = parent.querySelector('.TextEditorApp');
    const LeftAlign = BaseElement.querySelector('.TextEditorApp-left');
    const CenterAlign = BaseElement.querySelector('.TextEditorApp-center');
    const RightAlign = BaseElement.querySelector('.TextEditorApp-right');
    const RegularCase = BaseElement.querySelector('.TextEditorApp-case');
    const UpperCase = BaseElement.querySelector('.TextEditorApp-upper');
    const LowerCase = BaseElement.querySelector('.TextEditorApp-lower');
    const SpellCheck = BaseElement.querySelector('.TextEditorApp-spell');
    let alignment = 0;
    let casing = 0;
    function syncAlignment(a) {
        alignment = a;
        BaseElement.classList.toggle('is-center', alignment === 1);
        BaseElement.classList.toggle('is-right', alignment === 2);
        LeftAlign.classList.toggle(CLASS_ACTIVE, alignment === 0);
        CenterAlign.classList.toggle(CLASS_ACTIVE, alignment === 1);
        RightAlign.classList.toggle(CLASS_ACTIVE, alignment === 2);
    }
    LeftAlign.addEventListener('click', (e) => {
        e.stopPropagation();
        syncAlignment(0);
    });
    CenterAlign.addEventListener('click', (e) => {
        e.stopPropagation();
        syncAlignment(1);
    });
    RightAlign.addEventListener('click', (e) => {
        e.stopPropagation();
        syncAlignment(2);
    });
    function syncCasing(c) {
        casing = c;
        BaseElement.classList.toggle('is-upper', casing === 1);
        BaseElement.classList.toggle('is-lower', casing === 2);
        RegularCase.classList.toggle(CLASS_ACTIVE, casing === 0);
        UpperCase.classList.toggle(CLASS_ACTIVE, casing === 1);
        LowerCase.classList.toggle(CLASS_ACTIVE, casing === 2);
    }
    RegularCase.addEventListener('click', (e) => {
        e.stopPropagation();
        syncCasing(0);
    });
    UpperCase.addEventListener('click', (e) => {
        e.stopPropagation();
        syncCasing(1);
    });
    LowerCase.addEventListener('click', (e) => {
        e.stopPropagation();
        syncCasing(2);
    });
    SpellCheck.addEventListener('click', (e) => {
        e.stopPropagation();
        BaseElement.classList.toggle('is-spell');
        SpellCheck.classList.toggle(CLASS_ACTIVE);
    });
    syncAlignment(0);
    syncCasing(0);
}
function setupDocsApps() {
    const DocsWindow = document.querySelector('.DesktopWindow[data-id="documents"]');
    const DocsImageIcon1 = DocsWindow.querySelector('.FileIcon#documents-image-1');
    const DocsImageIcon2 = DocsWindow.querySelector('.FileIcon#documents-image-2');
    const DocsImageIcon3 = DocsWindow.querySelector('.FileIcon#documents-image-3');
    const DocsImageIcon4 = DocsWindow.querySelector('.FileIcon#documents-image-4');
    DocsImageIcon1.addEventListener('click', (e) => {
        e.stopPropagation();
        interfaceClick();
        openWindow('transmission', true);
    });
    DocsImageIcon2.addEventListener('click', (e) => {
        e.stopPropagation();
        interfaceClick();
        openWindow('firmament', true);
    });
    DocsImageIcon3.addEventListener('click', (e) => {
        e.stopPropagation();
        interfaceClick();
        openWindow('chantenay', true);
    });
    DocsImageIcon4.addEventListener('click', (e) => {
        e.stopPropagation();
        interfaceClick();
        openWindow('scarlet', true);
    });

    const DocsTextIcon1 = DocsWindow.querySelector('.FileIcon#documents-file-1');
    const DocsTextIcon2 = DocsWindow.querySelector('.FileIcon#documents-file-2');
    const DocsTextIcon3 = DocsWindow.querySelector('.FileIcon#documents-file-3');
    DocsTextIcon1.addEventListener('click', (e) => {
        e.stopPropagation();
        interfaceClick();
        openWindow('ready123', true);
    });
    DocsTextIcon2.addEventListener('click', (e) => {
        e.stopPropagation();
        interfaceClick();
        openWindow('openRoad', true);
    });
    DocsTextIcon3.addEventListener('click', (e) => {
        e.stopPropagation();
        interfaceClick();
        openWindow('virtuesOfPizza', true);
    });
    setupTextEditor(document.querySelector('.DesktopWindow[data-id="ready123"]'))
    setupTextEditor(document.querySelector('.DesktopWindow[data-id="openRoad"]'))
    setupTextEditor(document.querySelector('.DesktopWindow[data-id="virtuesOfPizza"]'))
}

function startAccessAudio() {
    playSound(AccessLoopAudio, 0.5);
}
function stopAccessAudio() {
    stopSound(AccessLoopAudio);
}

// Password-protected files
const passwords = [];
function syncPasswordProtection() {
    for (const password of passwords) password.sync();
}
function setupPassword(win, name, endpoint, validator) {
    if (!win) return;

    const parentElement = win.element;
    if (parentElement) {
        const BaseElement = parentElement.querySelector('.PasswordProtected');
        const FormElement = BaseElement.querySelector('form.PasswordProtected-form');
        const InputElement = BaseElement.querySelector('input.PasswordProtected-input');
        const ContentElement = BaseElement.querySelector('.PasswordProtected-content');
        let loading = false;
        const stateKey = name + 'Unlocked';
        const stateKeyKey = name + 'Key';

        function open() {
            if (!BaseElement.classList.contains(CLASS_LOADED) && endpoint) {
                BaseElement.classList.toggle(CLASS_LOADING, true);
                load(getAppState()[stateKeyKey]);
            } else if (BaseElement.hasAttribute('data-audio') && BaseElement.getAttribute('data-audio') === "access") {
                setTimeout(startAccessAudio, 500);
            }
        }
        function close() {
            if (BaseElement.hasAttribute('data-audio') && BaseElement.getAttribute('data-audio') === "access") {
                stopAccessAudio();
            }
        }
        const WindowCloser = parentElement.querySelector('.DesktopWindow-close');
        if (WindowCloser) {
            WindowCloser.addEventListener('click', close);
        }

        const load = async (passKey) => {
            loading = true;
            const route = window.PageData.re;
            const token = window.PageData.ct;
            const formData = new FormData();
            formData.append('_token', token);
            formData.append('key', passKey);
            const response = await fetch(route + '/' + endpoint, {
                method: 'POST',
                body: formData,
            })
            const data = await response.json();
            if (data.success) {
                ContentElement.innerHTML = data.content;

                getAppState()[stateKey] = true;
                getAppState()[stateKeyKey] = passKey;
                saveAppState();
                syncAppState();

                if (BaseElement.hasAttribute('data-audio') && BaseElement.getAttribute('data-audio') === "access") {
                    setTimeout(startAccessAudio, 1000);
                    centerWindow(parentElement, 0.5, 0.2);
                }
            }
            else
            {
                getAppState()[stateKey] = false;
                BaseElement.classList.toggle(CLASS_UNLOCKED, false);
            }
            BaseElement.classList.toggle(CLASS_LOADING, false);
            loading = false;
        }
        function sync() {
            BaseElement.classList.toggle(CLASS_UNLOCKED, getAppState()[stateKey]);
        }
        function submitHandler(e) {
            e.preventDefault();
            e.stopPropagation();
            if (loading) return;

            if (validator && validator(InputElement.value)) {
                BaseElement.classList.toggle(CLASS_ERROR, false);
                interfaceClick();
                load(InputElement.value).then(() => {
                    tryPushDataLayer({
                        event: 'button_click',
                        creative_title: getAppState()[stateKey] ? 'unlocked' : 'locked',
                        creative_type: 'button',
                        creative_placement: parentElement.getAttribute('data-id'),
                    });
                });
            }
            else
            {
                BaseElement.classList.toggle(CLASS_ERROR, true);
                interfaceClick(false);
                playSound(DecryptErrorAudio);

                tryPushDataLayer({
                    event: 'button_click',
                    creative_title: getAppState()[stateKey] ? 'unlocked' : 'locked',
                    creative_type: 'button',
                    creative_placement: parentElement.getAttribute('data-id'),
                });
            }
        }
        win.open = open;
        FormElement.addEventListener('submit', submitHandler);

        passwords.push({
            element: BaseElement,
            sync
        });
    }
}

function setupPasswordProtection() {
    if (window.PageData.keys) {
        for (const key of window.PageData.keys) {
            setupPassword(
                getWindow(key.id),
                key.id,
                key.endpoint,
                (value) => {
                    return key.hash && simpleHash(value.toLowerCase()) === key.hash;
                }
            );
        }
    }
}

// Hardware manager and repair app
const CLASS_REPAIRING = 'is-repairing';
const CLASS_COMPLETE = 'is-complete';
const RepairWindow = document.querySelector('.DesktopWindow[data-id="repair"]');
const RepairRoot = RepairWindow.querySelector('.RepairApp');
const RepairForm = RepairRoot.querySelector('form.RepairApp-form');
const RepairInput = RepairForm.querySelector('.RepairApp-input');
const RepairRunButton = RepairForm.querySelector('.RepairApp-button');
const RepairProgressText = RepairRoot.querySelector('.RepairApp-progressText');
const RepairProgressDrive = RepairProgressText.querySelector('.RepairApp-progressDrive');
const RepairProgressNumber = RepairProgressText.querySelector('.RepairApp-progressNum');
const RepairProgressBar = RepairRoot.querySelector('.RepairApp-progressBar');
const RepairProgressBarInner = RepairRoot.querySelector('.RepairApp-progressBarInner');
const RepairCloser = RepairRoot.querySelector('.RepairApp-close');
let isRepairing = false;

function resetRepairWindow() {
    if (isRepairing) return;
    RepairRoot.classList.toggle(CLASS_REPAIRING, false);
    RepairRoot.classList.toggle(CLASS_COMPLETE, false);
    RepairInput.value = "";
}

const RepairProgressSegments = 100;
const RepairProgressDistribution = Array(RepairProgressSegments);
let repairProgress;
let repairProgressInterval;
let repairDriveKey = null;
function generateProgressDistribution() {
    RepairProgressDistribution.fill(0, 0);
    let n;
    for (let i = 0; i < 100; i ++) {
        n = Math.random();
        n = 1 - (n * n * n);
        const segment = Math.floor(n * RepairProgressSegments);
        for (let j = segment; j < RepairProgressSegments; j ++) {
            RepairProgressDistribution[j] ++;
        }
    }
}
function checkRepairInput() {
    const str = RepairInput.value.trim().toLowerCase();
    if (str !== "") {
        const tokens = str.split(/\s+/g);
        if (tokens.length === 3 && tokens[0] === "chkdsk" && tokens[2] === "/r") {
            switch (simpleHash(tokens[1])) {
                case -3010472437:
                    RepairProgressBar.setAttribute('data-drive', 'a');
                    RepairProgressDrive.innerText = 'A:\\' + atob(window.PageData.hda);
                    repairDriveKey = "aRepaired";
                    startRepairProcess();
                    return;
                case 2772980775:
                    RepairProgressBar.setAttribute('data-drive', 'b');
                    RepairProgressDrive.innerText = 'B:\\' + atob(window.PageData.hdb);
                    repairDriveKey = "bRepaired";
                    startRepairProcess();
                    return;
                case -6807506199:
                    RepairProgressBar.setAttribute('data-drive', 'c');
                    RepairProgressDrive.innerText = 'D:\\' + atob(window.PageData.hdc);
                    repairDriveKey = "cRepaired";
                    startRepairProcess();
                    return;
                case -1870963307:
                    RepairProgressBar.setAttribute('data-drive', 'd');
                    RepairProgressDrive.innerText = 'D:\\' + atob(window.PageData.hdd);
                    repairDriveKey = "dRepaired";
                    startRepairProcess();
                    return;
            }
        }
    }
    playSound(DecryptErrorAudio);
}
function startRepairProcess() {
    isRepairing = true;
    generateProgressDistribution();
    repairProgress = 0;
    RepairProgressNumber.innerText = '0';
    RepairProgressBarInner.style.width = '100%';
    RepairRoot.classList.toggle(CLASS_REPAIRING, true);
    playSound(HardDriveAudio5s, 0.4);

    repairProgressInterval = setInterval(() => {
        repairProgress ++;
        if (repairProgress < RepairProgressSegments) {
            const val = RepairProgressDistribution[repairProgress];
            RepairProgressNumber.innerText = val;
            RepairProgressBarInner.style.width = (100 - val) + '%';
        } else {
            stopSound(HardDriveAudio5s);
            RepairRoot.classList.toggle(CLASS_COMPLETE, true);
            RepairProgressNumber.innerText = '100';
            RepairProgressBarInner.style.width = '0';
            clearInterval(repairProgressInterval);
            getAppState()[repairDriveKey] = true;
            saveAppState();
            syncAppState();
            isRepairing = false;
        }
    }, 50);
}

const HardwareWindow = document.querySelector('.DesktopWindow[data-id="hardware"]');
const HardwareRepairButton = HardwareWindow.querySelector('#hardware-repair');
const DriveAIcon = HardwareWindow.querySelector('.FileIcon#drive-a');
const DriveALabel = DriveAIcon.querySelector('.FileScrambledLabel');
const DriveAAccess = document.querySelector('.DesktopWindow[data-id="drive-a"] .DriveAccess');
const DriveBIcon = HardwareWindow.querySelector('.FileIcon#drive-b');
const DriveBLabel = DriveBIcon.querySelector('.FileScrambledLabel');
const DriveBAccess = document.querySelector('.DesktopWindow[data-id="drive-b"] .DriveAccess');
const DriveCIcon = HardwareWindow.querySelector('.FileIcon#drive-c');
const DriveCLabel = DriveCIcon.querySelector('.FileScrambledLabel');
const DriveCAccess = document.querySelector('.DesktopWindow[data-id="drive-c"] .DriveAccess');
const DriveDIcon = HardwareWindow.querySelector('.FileIcon#drive-d');
const DriveDLabel = DriveDIcon.querySelector('.FileScrambledLabel');
const DriveDAccess = document.querySelector('.DesktopWindow[data-id="drive-d"] .DriveAccess');
function syncHardware(appState) {
    DriveALabel.innerText = appState.aRepaired ? 'A:\\' + atob(window.PageData.hda) : 'A:\\Ceru̶̬̕le̵̅͜an';
    DriveAAccess.classList.toggle(CLASS_UNLOCKED, appState.aRepaired);
    DriveBLabel.innerText = appState.bRepaired ? 'B:\\' + atob(window.PageData.hdb) : 'B:\\O̷̠͠cḣ̸̰re';
    DriveBAccess.classList.toggle(CLASS_UNLOCKED, appState.bRepaired);
    DriveCLabel.innerText = appState.cRepaired ? 'C:\\' + atob(window.PageData.hdc) : 'C:\\V̸erm̷̦͌illió̷̗n';
    DriveCAccess.classList.toggle(CLASS_UNLOCKED, appState.cRepaired);
    DriveDLabel.innerText = appState.dRepaired ? 'D:\\' + atob(window.PageData.hdd) : 'D:\\@̵̳̃%̶̞̑*̵̹̄#̷̱͗&̵͓͛$̶';
    DriveDAccess.classList.toggle(CLASS_UNLOCKED, appState.dRepaired);
}
function setupHardware() {
    HardwareRepairButton.addEventListener('click', (e) => {
        e.stopPropagation();
        interfaceClick(false);
        if (!isWindowOpen('repair')) {
            playSound(WindowOpenAudio);
            resetRepairWindow();
        }
        openWindow('repair', true);
        RepairInput.focus();
    });
    RepairForm.addEventListener('submit', (e) => {
        e.preventDefault()
        e.stopPropagation();

        if (isRepairing) return;
        checkRepairInput();
    });
    RepairRunButton.addEventListener('click', (e) => {
        e.stopPropagation();

        if (isRepairing) return;
        checkRepairInput();
    });
    RepairCloser.addEventListener('click', (e) => {
       e.stopPropagation();
       if (isRepairing) return;
       closeWindow('repair', true);
    });
    DriveAIcon.addEventListener('click', (e) => {
        e.stopPropagation();
        interfaceClick();
        if (getAppState().aRepaired) {
            playSound(DriveRepairedAudio);
        }
        else {
            playSound(DriveCorruptedAudio);
        }
        openWindow('drive-a', true);
    });
    DriveBIcon.addEventListener('click', (e) => {
        e.stopPropagation();
        interfaceClick();
        if (getAppState().bRepaired) {
            playSound(DriveRepairedAudio);
        }
        else {
            playSound(DriveCorruptedAudio);
        }
        openWindow('drive-b', true);
    });
    DriveCIcon.addEventListener('click', (e) => {
        e.stopPropagation();
        interfaceClick();
        if (getAppState().cRepaired) {
            playSound(DriveRepairedAudio);
        }
        else {
            playSound(DriveCorruptedAudio);
        }
        openWindow('drive-c', true);
    });
    DriveDIcon.addEventListener('click', (e) => {
        e.stopPropagation();
        interfaceClick();
        if (getAppState().contactRevealed) {
            playSound(DriveRecoverAudio);
        }
        else {
            if (getAppState().dRepaired) {
                playSound(DriveOpenAudio);
            } else {
                playSound(DriveCorruptedAudio);
            }
            openWindow('drive-d', true);
        }
    });
    const DriveDRecover = DriveDAccess.querySelector('.DriveAccess-recover');
    DriveDRecover.addEventListener('click', (e) => {
        e.stopPropagation();
        interfaceClick(false)
        playSound(DriveRecoverAudio);
        closeWindow('drive-d');
        getAppState().contactRevealed = true;
        saveAppState();
        syncAppState();
    });
}

// Network app
const NetworkWindow = document.querySelector('.DesktopWindow[data-id="network"]');
const NetworkCloser = NetworkWindow.querySelector('.DesktopWindow-close');
const NetworkRoot = NetworkWindow.querySelector('.NetworkApp');
const NetworkConnect = NetworkRoot.querySelector('.NetworkApp-connect');
const NetworkCancel = NetworkRoot.querySelector('.NetworkApp-cancel');
let networkTimeout = null;

function networkOpen() {
    NetworkRoot.setAttribute('data-state', "0");
    interfaceClick(false);
    openWindow('network', true, true);
}
function networkConnect() {
    NetworkRoot.setAttribute('data-state', "1");
    if (window.PageData.mall) {
        playSound(ConnectedAudio);
        networkTimeout = setTimeout(networkSuccess, 26000);
    }
    else
    {
        playSound(ConnectAudio);
        networkTimeout = setTimeout(networkFail, 26000);
    }
}
function networkCancel() {
    clearTimeout(networkTimeout);
    networkStopAudio();
    interfaceClick(true);
    NetworkRoot.setAttribute('data-state', "0");
}
function networkSuccess() {
    NetworkRoot.setAttribute('data-state', "2");
}
function networkFail() {
    NetworkRoot.setAttribute('data-state', "3");
}
function networkStopAudio() {
    stopSound(ConnectAudio);
    stopSound(ConnectedAudio);
}

function setupNetwork() {
    NetworkCloser.addEventListener('click', networkStopAudio);
    NetworkConnect.addEventListener('click', networkConnect);
    NetworkCancel.addEventListener('click', networkCancel);
}

// Music player
const MusicWindow= document.querySelector('.DesktopWindow[data-id="llama"]');
const MusicRoot = MusicWindow.querySelector('.MusicPlayer');
const MusicTitle = MusicRoot.querySelector('.MusicPlayer-title');
const MusicTime = MusicRoot.querySelector('.MusicPlayer-time');
const MusicPlayButton = MusicRoot.querySelector('.MusicPlayer-play');
const MusicPauseButton = MusicRoot.querySelector('.MusicPlayer-pause');
const MusicStopButton = MusicRoot.querySelector('.MusicPlayer-stop');
const MusicTracks = MusicRoot.querySelector('.MusicPlayer-tracks');
const MusicTrackRows = MusicTracks.querySelectorAll('.MusicPlayer-tracksRow');
const MusicTrackToggle = MusicTracks.querySelector('.MusicPlayer-toggle');
const MusicTrackAudio = new Array(window.PageData.audio.length);
let musicTrackIndex = 0;
let musicTitle = null;
let musicFlicker = false;
let musicToggle = 0;

function getCurrentMusicTrack(sync=false) {
    if (MusicTrackAudio[musicTrackIndex] == null) {
        const data = window.PageData.audio[musicTrackIndex];
        MusicTrackAudio[musicTrackIndex] = new Audio(data.path);
        sync = true;
    }
    if (sync) {
        const data = window.PageData.audio[musicTrackIndex];
        musicTitle = data.fullTitle + " ---- ";
    }
    return MusicTrackAudio[musicTrackIndex];
}
function changeMusicTrack(index) {
    if (index !== musicTrackIndex) {
        MusicTrackAudio.forEach((audio) => {
            if (audio !== null && !audio.paused) {
                audio.pause();
                audio.currentTime = 0;
            }
        });
        musicTrackIndex = index;
        getCurrentMusicTrack(true);
        syncMusicPlayerControls(true);
        syncAppState();
    }
}
function syncMusicPlayerControls() {
    const musicTrack = getCurrentMusicTrack();
    if (musicTrack != null) {
        MusicRoot.classList.toggle('is-playing', !musicTrack.paused);
        MusicRoot.classList.toggle('is-paused', musicTrack.paused && musicTrack.currentTime > 0);
        MusicRoot.classList.toggle('is-stopped', musicTrack.paused && musicTrack.currentTime === 0);
    }
}
function syncMusicPlayerUI() {
    const MusicIcon = document.querySelector('.FileIcon[data-file="llama"]');
    MusicIcon.classList.toggle(CLASS_HIDDEN, !getAppState().llamaUnlocked);
    MusicIcon.addEventListener('click', (e) => {
        e.stopPropagation();
        interfaceClick(false);
        if (!isWindowOpen('llama')) playSound(WindowOpenAudio);
        openWindow('llama');
    });
    if (MusicTrackRows && MusicTrackRows.length > 1) {
        MusicTrackRows[1].classList.toggle(CLASS_HIDDEN, !getAppState().numbersUnlocked);
        MusicTrackRows.forEach((row, index) => {
            row.classList.toggle(CLASS_ACTIVE, index === musicTrackIndex);
        });
    }
}
function musicTick() {
    if (MusicWindow.classList.contains(CLASS_ACTIVE)) {
        const musicTrack = getCurrentMusicTrack();
        musicTitle = musicTitle.substring(1) + musicTitle.substring(0, 1);
        MusicTitle.innerText = musicTitle;

        if (musicTrack != null) {
            const minutes = Math.floor(musicTrack.currentTime / 60);
            const seconds = Math.floor(musicTrack.currentTime % 60);
            const duration = minutes.toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping: false}) + ':' + seconds.toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping: false});
            if (!musicTrack.paused) musicTrack.volume = getAppState().volume;
            if (!musicTrack.paused || musicTrack.currentTime === 0) {
                musicFlicker = false;
            } else {
                musicFlicker = Math.floor(Date.now() / 1000) % 2 === 0;
            }
            MusicTime.innerText = duration;
            MusicTime.classList.toggle('is-flicker', musicFlicker);
            syncMusicPlayerControls();
        }
    } else if (MusicTrackAudio[musicTrackIndex] != null && !MusicTrackAudio[musicTrackIndex].paused) {
        MusicTrackAudio[musicTrackIndex].pause();
    }
}
function setupMusicPlayer() {
    musicTitle = MusicTitle.innerText;

    function playHandler(e) {
        e.stopPropagation();
        const musicTrack = getCurrentMusicTrack();
        if (musicTrack.paused) {
            musicTrack.volume = getAppState().volume;
            musicTrack.play().then(() => {
                syncMusicPlayerControls();
            });
        }
        musicToggle = 0;
    }
    function pauseHandler(e) {
        e.stopPropagation();
        const musicTrack = getCurrentMusicTrack();
        if (musicTrack != null && !musicTrack.paused) {
            musicTrack.pause();
            syncMusicPlayerControls();
        }
        musicToggle = 0;
    }
    function stopHandler(e) {
        e.stopPropagation();
        const musicTrack = getCurrentMusicTrack();
        if (musicTrack != null) {
            if (!musicTrack.paused) {
                musicTrack.pause();
            }
            musicTrack.currentTime = 0;
            syncMusicPlayerControls();
        }
        musicToggle ++;
        if (musicToggle > 2) {
            getAppState().numbersUnlocked = true;
            saveAppState();
            syncAppState();
            playSound(DecryptStepAudio);
        }
    }

    MusicPlayButton.addEventListener('click', playHandler);
    MusicPauseButton.addEventListener('click', pauseHandler);
    MusicStopButton.addEventListener('click', stopHandler);

    MusicTrackToggle.addEventListener('click', (e) => {
       MusicRoot.classList.toggle(CLASS_OPEN);
    });
    if (MusicTrackRows) {
        if (MusicTrackRows.length > 0) {
            MusicTrackRows[0].addEventListener('click', (e) => {
                e.stopPropagation();
                changeMusicTrack(0);
            });
        }
        if (MusicTrackRows.length > 1) {
            MusicTrackRows[1].addEventListener('click', (e) => {
                e.stopPropagation();
                changeMusicTrack(1);
            });
        }
    }

    setInterval(musicTick, 500);
}

// Wallpapers and screensavers
const SettingsWindow = document.querySelector('.DesktopWindow[data-id="settings"]');
const SystemTime = SettingsWindow.querySelector('.SystemSettings-time');
const SystemLanguage = SettingsWindow.querySelector('.SystemSettings-currentLanguage');
const VolumeOptions = SettingsWindow.querySelectorAll('.SystemSettings-volumeOption');
const WallpaperOptions = SettingsWindow.querySelectorAll('.SystemSettings-wallpaper');
const ScreensaverOptions = SettingsWindow.querySelectorAll('.SystemSettings-screensaver');
function syncSettings() {
    VolumeOptions.forEach((option, index) => {
        const appState = getAppState();
        const value = index * 0.25;
        option.classList.toggle('is-over', value < appState.volume);
        option.classList.toggle(CLASS_ACTIVE, value === appState.volume);
    });
    WallpaperOptions.forEach((option, index) => {
        option.classList.toggle(CLASS_ACTIVE, index === getAppState().activeWallpaper);
    });
    ScreensaverOptions.forEach((option, index) => {
        option.classList.toggle(CLASS_ACTIVE, index === getAppState().activeScreensaver);
    });
    const appState = getAppState();
    MessageBoardBackground.setAttribute('data-option', appState.activeWallpaper);
    Screensavers.updateMode(appState.activeScreensaver);
}
function setupSettings() {
    VolumeOptions.forEach((option, index) => {
        const value = index * 0.25;
        option.addEventListener('click', (e) => {
            e.stopPropagation();
            getAppState().volume = value;
            saveAppState();
            syncAppState();
            interfaceClick();
        });
    });
    SystemLanguage.addEventListener('click', (e) => {
       e.stopPropagation();
       SystemLanguage.classList.toggle(CLASS_ACTIVE);
       interfaceClick();
    });
    let ollies = 0;
    WallpaperOptions.forEach((option, index) => {
        option.addEventListener('click', (e) => {
            e.stopPropagation();

            if (index === 1) {
                ollies ++;
                if (ollies > 2) {
                    playSound(OllieMovesAudio);
                    ollies = 0;
                }
            } else {
                ollies = 0;
            }

            if (getAppState().activeWallpaper !== index) {
                getAppState().activeWallpaper = index;
                saveAppState();
                syncSettings();
                interfaceClick();
            }
        });
    });
    ScreensaverOptions.forEach((option, index) => {
        option.addEventListener('click', (e) => {
            e.stopPropagation();
            if (getAppState().activeScreensaver !== index) {
                getAppState().activeScreensaver = index;
                saveAppState();
                syncSettings();
                interfaceClick();
            }
        });
    });
}
function setupActivityTracking() {
    MessageBoardElement.addEventListener('mousemove', updateUserActivity);
}

let lastPrintedTime = null;
function animationTick() {
    const timestamp = Date.now();
    Screensavers.update(timestamp, lastUserActivity);

    // Update system time in settings app
    if (SettingsWindow.classList.contains(CLASS_ACTIVE)) {
        let currentTime = (new Date().toTimeString().split(" "))[0];
        if (currentTime.length < 8) currentTime = '0' + currentTime;
        if (lastPrintedTime !== currentTime) {
            SystemTime.innerText = currentTime;
            lastPrintedTime = currentTime;
        }
    }

    requestAnimationFrame(animationTick);
}

let comboKeyA = false;
let comboKeyB = false;
let comboKeyC = false;
function checkFocusedChatLog() {
    if (activeWindows.length > 0) {
        const activeWindow = activeWindows[activeWindows.length - 1];
        if (activeWindow.element.classList.contains('DesktopWindow--log')) {
            const password = activeWindow.element.querySelector('.PasswordProtected');
            if (password == null || password.classList.contains(CLASS_UNLOCKED)) {
                return true;
            }
        }
    }
    return false;
}
function keyDownHandler(e) {
    switch (e.key) {
        case "h":
        case "H":
            if (checkFocusedChatLog()) {
                openWindow('help');
                interfaceClick();
            }
            return;
        /*
        case "q":
        case "Q":
            if (checkFocusedChatLog()) {
                closeWindow();
                interfaceClick(false);
                playSound(FileCloseAudio);
            }
            return;
        */
    }

    if (getAppState().biteRevealed) return;
    switch (e.key) {
        case " ":
            comboKeyA = true;
            if (comboKeyB && comboKeyC) revealBiteFile();
            break;
        case "6":
        case "^":
            comboKeyB = true;
            if (comboKeyA && comboKeyC) revealBiteFile();
            break;
        case "Shift":
            comboKeyC = true;
            if (comboKeyA && comboKeyB) revealBiteFile();
            break;
        default:
            comboKeyA = false;
            comboKeyB = false;
            comboKeyC = false;
            break;
    }
}
function keyUpHandler(e) {
    if (getAppState().biteRevealed) return;
    switch (e.key) {
        case " ":
            comboKeyA = false;
            break;
        case "6":
        case "^":
            comboKeyB = false;
            break;
        case "Shift":
            comboKeyC = false;
            break;
    }
}
function revealBiteFile() {
    playSound(DecryptStepAudio);
    getAppState().biteRevealed = true;
    saveAppState();
    syncAppState();

    tryPushDataLayer({
        event: 'button_click',
        creative_title: 'unlocked',
        creative_type: 'button',
        creative_placement: 'documents',
    });
}

function simpleHash(str) {
    return str.split('').reduce((hash, char) => {
        return char.charCodeAt(0) + (hash << 6) + (hash << 16) - hash;
    }, 0);
}

const PowerOverlayBase = document.querySelector('.PowerOverlay');
const PowerOverlayDark = PowerOverlayBase.querySelector('.PowerOverlay-dark');
const PowerOverlayWait = PowerOverlayBase.querySelector('.PowerOverlay-wait');
const PowerOverlaySafe = PowerOverlayBase.querySelector('.PowerOverlay-safe');
const PowerOverlayGlitch = PowerOverlayBase.querySelector('.PowerOverlay-glitch');
const PowerOverlayStart = PowerOverlayBase.querySelector('.PowerOverlay-start');
const PowerOverlayReflection = PowerOverlayBase.querySelector('.PowerOverlay-reflection');
const PowerOverlayReflection2 = PowerOverlayBase.querySelector('.PowerOverlay-reflectionOverlay');
function startPowerCycle() {
    interfaceClick();
    PowerOverlayBase.classList.toggle(CLASS_ACTIVE, true);
    PowerOverlayDark.classList.toggle(CLASS_ACTIVE, false);
    PowerOverlayWait.classList.toggle(CLASS_ACTIVE, false);
    PowerOverlaySafe.classList.toggle(CLASS_ACTIVE, false);
    PowerOverlaySafe.classList.toggle('is-glitch', false);
    PowerOverlayGlitch.classList.toggle(CLASS_ACTIVE, false);
    PowerOverlayStart.classList.toggle(CLASS_ACTIVE, false);
    PowerOverlayReflection.classList.toggle(CLASS_ACTIVE, false);
    PowerOverlayReflection2.classList.toggle(CLASS_ACTIVE, false);
    setTimeout(startPowerFadeOut, 1000);
}
function startPowerFadeOut() {
    playSound(PowerOffAudio);
    PowerOverlayDark.classList.toggle(CLASS_ACTIVE, true);
    PowerOverlayWait.classList.toggle(CLASS_ACTIVE, true);
    setTimeout(startPowerOff, 3000);
}
function startPowerOff() {
    closeAllWindows();
    PowerOverlayWait.classList.toggle(CLASS_ACTIVE, false);
    PowerOverlaySafe.classList.toggle(CLASS_ACTIVE, true);
    setTimeout(startPowerGlitch, 3000);
    setTimeout(startPowerCold, 5000);

    tryPushDataLayer({
        event: 'button_click',
        creative_title: 'off',
        creative_type: 'button',
        creative_placement: 'power',
    });
}
function startPowerGlitch() {
    PowerOverlaySafe.classList.toggle('is-glitch', true);
    PowerOverlayGlitch.classList.toggle(CLASS_ACTIVE, true);
}
function startPowerCold() {
    PowerOverlaySafe.classList.toggle(CLASS_ACTIVE, false);
    PowerOverlaySafe.classList.toggle('is-glitch', false);
    PowerOverlayGlitch.classList.toggle(CLASS_ACTIVE, false);
    PowerOverlayReflection.classList.toggle(CLASS_ACTIVE, true);
    PowerOverlayReflection2.classList.toggle(CLASS_ACTIVE, true);
    setTimeout(startPowerOn, 2000);
    updateUserActivity();
}
function startPowerOn() {
    playSound(PowerOnAudio);
    PowerOverlayDark.classList.toggle(CLASS_ACTIVE, false);
    PowerOverlayStart.classList.toggle(CLASS_ACTIVE, true);
    PowerOverlayReflection.classList.toggle(CLASS_ACTIVE, false);
    PowerOverlayReflection2.classList.toggle(CLASS_ACTIVE, false);
    setTimeout(stopPowerLogo, 2000);
    setTimeout(endPowerCycle, 4000);
}
function stopPowerLogo() {
    PowerOverlayStart.classList.toggle(CLASS_ACTIVE, false);
}
function endPowerCycle() {
    PowerOverlayBase.classList.toggle(CLASS_ACTIVE, false);
    PowerOverlayDark.classList.toggle(CLASS_ACTIVE, false);
    PowerOverlayWait.classList.toggle(CLASS_ACTIVE, false);
    PowerOverlaySafe.classList.toggle(CLASS_ACTIVE, false);
    PowerOverlayGlitch.classList.toggle(CLASS_ACTIVE, false);
    PowerOverlayStart.classList.toggle(CLASS_ACTIVE, false);
    PowerOverlayReflection.classList.toggle(CLASS_ACTIVE, false);
    PowerOverlayReflection2.classList.toggle(CLASS_ACTIVE, false);
    updateUserActivity();
}

function setup() {
    // Set up draggability
    if (WindowElements) {
        let count = 0;
        WindowElements.forEach((el) => {
            const positioning = el.getAttribute('data-position');
            const isAppWindow = el.classList.contains('DesktopWindow--app');

            // Initial position
            let reset;
            if (positioning === 'centered') {
                reset = () => {
                    centerWindow(el);
                };
            } else {
                const initialTop = (64 + (count % 5) * 8);
                const initialLeft = (160 + (count % 5) * 8);
                el.style.top = initialTop + 'px';
                el.style.left = initialLeft + 'px';
                count ++;
                reset = () => {
                    el.style.top = initialTop + 'px';
                    el.style.left = initialLeft + 'px';
                };
            }

            const id = el.getAttribute('data-id');

            const win = {
                id,
                element: el,
                reset,
            };

            // Focus window on click
            el.addEventListener('click', (e) => {
                syncWindowStack(win);
            });

            // Close button
            const closer = el.querySelector('.DesktopWindow-close');
            if (closer) {
                closer.addEventListener('click', (e) => {
                    e.stopPropagation();
                    closeWindow(id);
                    interfaceClick(false);
                    if (isAppWindow) playSound(WindowCloseAudio);
                    else playSound(FileCloseAudio);
                });
            }

            // Drag anchor
            const draggable = el.querySelector('.DesktopWindow-titleBar');
            let startX, startY, startLeft, startTop;
            let deltaX, deltaY;

            function getClientPos(e) {
                if (e.touches && e.touches.length > 0) {
                    return {
                        x: e.touches[0].clientX,
                        y: e.touches[0].clientY
                    };
                }

                return {
                    x: e.clientX,
                    y: e.clientY
                };
            }

            function dragStart(e) {
                e.preventDefault();

                syncWindowStack(win);

                const {x, y} = getClientPos(e);
                startX = x;
                startY = y;
                startLeft = el.offsetLeft;
                startTop = el.offsetTop;

                document.addEventListener('mousemove', drag);
                document.addEventListener('mouseup', dragStop);
            }

            function drag(e) {
                e.preventDefault();
                const {x, y} = getClientPos(e);
                deltaX = x - startX;
                deltaY = y - startY;

                el.style.left = (startLeft + deltaX) + 'px';
                el.style.top = (startTop + deltaY) + 'px';
            }

            function dragStop(e) {
                e.preventDefault();
                document.removeEventListener('mousemove', drag);
                document.removeEventListener('mouseup', dragStop);
            }

            draggable.addEventListener('mousedown', dragStart);

            windows.push(win);
        });
    }

    // Set up icons
    if (window.PageData.files) {
        for (const data of window.PageData.files) {
            addFileIcon(data);
        }
    }
    //openWindow('entrati');

    // Hotbar icons
    if (HotBarSettings) {
        HotBarSettings.addEventListener('click', (e) => {
            e.stopPropagation();
            interfaceClick(false);
            if (!isWindowOpen('settings')) playSound(WindowOpenAudio);
            openWindow('settings');
        });
    }
    if (HotBarEmail) {
        HotBarEmail.addEventListener('click', (e) => {
            e.stopPropagation();
            openEmailWindow();
        });
    }
    if (HotBarSearch) {
        HotBarSearch.addEventListener('click', (e) => {
            e.stopPropagation();
            openSearchWindow();
        });
    }
    if (HotBarDocuments) {
        HotBarDocuments.addEventListener('click', (e) => {
            e.stopPropagation();
            interfaceClick(false);
            if (!isWindowOpen('documents')) playSound(WindowOpenAudio);
            openWindow('documents', true);
        });
    }
    if (HotBarDatabase) {
        HotBarDatabase.addEventListener('click', (e) => {
            e.stopPropagation();
            interfaceClick(false);
            if (!isWindowOpen('access')) playSound(WindowOpenAudio);
            openWindow('access', true);
        });
    }
    if (HotBarHardware) {
        HotBarHardware.addEventListener('click', (e) => {
            e.stopPropagation();
            interfaceClick(false);
            if (!isWindowOpen('hardware')) playSound(WindowOpenAudio);
            openWindow('hardware');
        });
    }
    if (HotBarNetworking) {
        HotBarNetworking.addEventListener('click', (e) => {
            e.stopPropagation();
            networkOpen();
        });
    }
    if (HotBarRecycle) {
        HotBarRecycle.addEventListener('click', (e) => {
            e.stopPropagation();
            interfaceClick(false);
            if (!isWindowOpen('recycle')) playSound(WindowOpenAudio);
            openWindow('recycle');
        });
    }
    if (HotBarPower) {
        HotBarPower.addEventListener('click', (e) => {
            e.stopPropagation();
            startPowerCycle();
        });
    }

    // Email app
    setupEmailApp();

    // Browser/search
    setupSearchApp();

    // Decrypt app
    setupDecryptApp();

    // Oubliette unzip
    const OublietteUnzipButton = document.querySelector('.DesktopWindow[data-id="oubliette"] .UnzipFolder-button');
    OublietteUnzipButton && OublietteUnzipButton.addEventListener('click', unzipOubliette);

    // Docs
    setupDocsApps();

    // Chat log miscellanea
    const ChatLogs = document.querySelectorAll('.ChatLog');
    if (ChatLogs) {
        ChatLogs.forEach((log) => {
            log.addEventListener('scroll', () => {
                updateUserActivity();
            });
        });
    }

    // Hardware manager / repair
    addSyncHandler(syncHardware);
    setupHardware();

    // Network
    setupNetwork();

    // Recycle bin
    const RecycleRestore = document.getElementById('recycle-restore');
    if (RecycleRestore) {
        RecycleRestore.addEventListener('click', (e) => {
            e.stopPropagation();
            interfaceClick();
            getAppState().recycleRestored = true;
            saveAppState();
            syncAppState();
        });
    }

    // Settings
    setupSettings();

    // Password protection
    setupPasswordProtection();

    // Music player
    setupMusicPlayer();

    // Activity tracking for screensavers
    setupActivityTracking();

    // Key handlers
    window.addEventListener('keydown', keyDownHandler);
    window.addEventListener('keyup', keyUpHandler);

    // Load state from localStorage
    addSyncHandler(appSyncHandler);
    loadAppState();

    // Start animation ticking
    Screensavers.setup(updateUserActivity, (e) => {
        e.stopPropagation();
        getAppState().speakRevealed = true;
        saveAppState();
        syncAppState();
        interfaceClick(false);
        playSound(DecryptSuccessAudio, 0.5);

        tryPushDataLayer({
            event: 'button_click',
            creative_title: 'unlock',
            creative_type: 'button',
            creative_placement: 'screensaver',
        });
    });
    requestAnimationFrame(animationTick);

    // Reset button
    const ResetButton = document.querySelector('.ResetButton');
    if (ResetButton) {
        ResetButton.addEventListener('click', (e) => {
            if (window.confirm("Reset all progress?")) {
                restoreAppState();
                syncAppState();
                interfaceClick();
                closeAllWindows();
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    setup();
});
